import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=1f02478c"
import script from "./Messaging.vue?vue&type=script&lang=js"
export * from "./Messaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f02478c')) {
      api.createRecord('1f02478c', component.options)
    } else {
      api.reload('1f02478c', component.options)
    }
    module.hot.accept("./Messaging.vue?vue&type=template&id=1f02478c", function () {
      api.rerender('1f02478c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Messaging.vue"
export default component.exports